import React from 'react';
import styles from './FullWidthImage.module.css';

const FullWidthImage = React.forwardRef(
  /**
   * @param {object} props
   * @param {String=} props.className
   * @param {React.ReactNode} props.children
   * @param {React.ReactElement|null=} props.media
   * @param {Boolean=} props.withScrim
   * @param {number=} props.containerMaxHeight
   */
  ({ children, className = '', media, withScrim, ...otherProps }, ref) => (
    <div className={`${styles.wrapper} ${className}`} ref={ref}>
      {media &&
        React.cloneElement(media, {
          ...otherProps,
          className: `${
            withScrim ? styles.darkenedMediaWrapper : styles.mediaWrapper
          } ${media.props.className || ''}`,
        })}
      {children}
    </div>
  ),
);

export default FullWidthImage;
